
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLogic04Off as ObiLogic04OffElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-logic-04-off.js';
 
 
 

 
 export const ObiLogic04Off = createComponent({
   react: React,
   tagName: 'obi-logic-04-off',
   elementClass: ObiLogic04OffElement,
   events: {
     
   }
  });
 
 